import { Config } from './config-type'

export const config: Config = {
  SYSTEM_ENV: 'itg-preview',
  GTM_ID: 'GTM-WQSRJGJ',
}